import {
  getAuth,
  onAuthStateChanged as _onAuthStateChanged,
  signInWithEmailAndPassword as _signInWithEmailAndPassword,
  createUserWithEmailAndPassword as _createUserWithEmailAndPassword,
  sendPasswordResetEmail as _sendPasswordResetEmail,
  signOut as _signOut,
  reauthenticateWithCredential as _reauthenticateWithCredential,
  updatePassword as _updatePassword,
  EmailAuthProvider as _EmailAuthProvider,
} from 'firebase/auth';
import app from './firebase-app';

const rawAuth = getAuth(app);

export namespace FirebaseAuthTypes {
  export interface User {
    uid: string;
    email: string | null;
    displayName: string | null;
    emailVerified: boolean;
    isAnonymous: boolean;
    photoURL: string | null;
  }
}

function wrapUser(user: any) {
  if (!user) return null;
  if (user._wrapped) return user;

  const wrapped = Object.create(Object.getPrototypeOf(user));
  Object.assign(wrapped, user);

  wrapped._wrapped = true;
  wrapped.reauthenticateWithCredential = (credential: any) =>
    _reauthenticateWithCredential(user, credential);
  wrapped.updatePassword = (newPassword: string) =>
    _updatePassword(user, newPassword);

  return wrapped;
}

const authWrapper = {
  get currentUser() {
    return wrapUser(rawAuth.currentUser);
  },
  onAuthStateChanged(callback: (user: any) => void) {
    return _onAuthStateChanged(rawAuth, (user) => callback(wrapUser(user)));
  },
  signInWithEmailAndPassword(email: string, password: string) {
    return _signInWithEmailAndPassword(rawAuth, email, password);
  },
  createUserWithEmailAndPassword(email: string, password: string) {
    return _createUserWithEmailAndPassword(rawAuth, email, password);
  },
  sendPasswordResetEmail(email: string) {
    return _sendPasswordResetEmail(rawAuth, email);
  },
  signOut() {
    return _signOut(rawAuth);
  },
};

const auth = () => authWrapper;

auth.EmailAuthProvider = _EmailAuthProvider;

export default auth;
